import { useGlobal } from '../context/GlobalContext';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import api from '../api/axios';
import { formatProductData } from '../helper/formatProductData';
import { ProductSliderSkeleton } from './SkeletonLoader';

const NewArrivalOne = (props) => {
    const { addToCart, cartItems, wishlistItems, addToWishlist, removeFromWishlist } = useGlobal();
    const [productsData, setProductsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await api.get('/api/products');
                const formatted = response.data.map(formatProductData).filter(p => p.isNewArrival);
                // Simple sort descending by ID as a fallback for 'new'
                /* formatted.sort eliminated */
                setProductsData(formatted);
            } catch (err) {
                console.error("Failed to fetch new arrival products", err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    };

    // Filter logic if needed, currently falls back to just showing the latest 10
    const newArrivalsProducts = productsData.filter(p => !p.category || !p.category.toLowerCase().includes('family pack')).slice(0, 10);

    return (
        <section className="new-arrival py-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0 wow fadeInLeft" data-wow-duration="0.7s">New Arrivals</h5>
                        <div className="flex-align mr-point gap-16 wow fadeInRight" data-wow-duration="0.7s">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All
                            </Link>
                        </div>
                    </div>
                </div>
                <style>{`
                    .pl-wishlist-btn {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 5;
                        transition: all 0.2s ease;
                        cursor: pointer;
                    }
                    .pl-wishlist-btn:hover {
                        transform: scale(1.1);
                    }
                    .new-arrival .product-card__cart {
                        white-space: nowrap;
                        z-index: 4;
                    }
                    @media (max-width: 576px) {
                        .pl-wishlist-btn {
                            top: 6px;
                            left: 6px;
                            width: 26px;
                            height: 26px;
                        }
                        .pl-wishlist-btn i {
                            font-size: 13px;
                        }
                        .new-arrival .product-card__cart {
                            font-size: 11px !important;
                            padding: 3px 8px !important;
                            margin-top: 6px !important;
                            margin-right: 6px !important;
                            gap: 4px !important;
                        }
                        .new-arrival .product-card__cart i {
                            font-size: 12px !important;
                        }
                    }
                    @media (max-width: 380px) {
                        .new-arrival .product-card__cart {
                            font-size: 10px !important;
                            padding: 2px 6px !important;
                            margin-top: 4px !important;
                            margin-right: 4px !important;
                            gap: 3px !important;
                        }
                    }
                `}</style>
                <div className="new-arrival__slider arrow-style-two">
                    {loading ? (
                        <ProductSliderSkeleton count={5} />
                    ) : (
                        <Slider {...settings}>
                            {newArrivalsProducts.map((product) => {
                            const isInCart = cartItems?.some(item => String(item.id) === String(product.id));
                            const isWishlisted = wishlistItems?.some(item => String(item.id) === String(product.id));
                            return (
                            <div key={product.id} style={{ height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                                <div className="product-card hover-lift p-12 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 d-flex flex-column" style={{ height: '100%', width: '100%' }}>
                                    {/* Wishlist Button */}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (isWishlisted) {
                                                removeFromWishlist(product.id);
                                            } else {
                                                addToWishlist(product);
                                            }
                                        }}
                                        className={`pl-wishlist-btn border ${
                                            isWishlisted
                                                ? 'bg-danger-50 border-danger-200 text-danger-600'
                                                : 'bg-white border-gray-100 text-gray-400 hover-text-main-600 hover-border-main-600 shadow-xs'
                                        }`}
                                        title={isWishlisted ? "In Wishlist (Click to remove)" : "Add to Wishlist"}
                                        aria-label="Wishlist"
                                    >
                                        <i className={`${isWishlisted ? 'ph-fill ph-heart text-danger-600' : 'ph ph-heart'} text-sm`} />
                                    </button>
                                    {/* 1. Photo */}
                                    <Link
                                        to={`/product-details/${product.slug || product.id}`}
                                        className="product-card__thumb flex-center"
                                        style={{ height: '130px', width: '100%', padding: '4px' }}
                                    >
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            style={{ width: 'auto', height: '100%', maxWidth: '100%', maxHeight: '120px', objectFit: 'contain' }}
                                        />
                                    </Link>

                                    {/* 2. Middle: Add to Cart / View Cart Button */}
                                    <div className="product-card__action my-8 w-100">
                                        {isInCart ? (
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-600 text-white hover-bg-main-700 py-8 px-14 text-xs rounded-pill flex-center gap-6 w-100"
                                            >
                                                View Cart <i className="ph ph-shopping-cart" />
                                            </Link>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={(e) => { e.preventDefault(); addToCart(product, 1, (product.rawVariants && product.rawVariants.length > 0) ? product.rawVariants[0] : null); }}
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-8 px-14 text-xs rounded-pill flex-center gap-6 w-100"
                                            >
                                                Add to Cart <i className="ph ph-shopping-cart" />
                                            </button>
                                        )}
                                    </div>

                                    {/* 3. Text details (Price & Name) */}
                                    <div className="product-card__content mt-4 flex-shrink-0 d-flex flex-column" style={{ flex: '1 1 auto' }}>
                                        <div className="product-card__price mb-4 d-flex align-items-center gap-8">
                                            <span className="text-heading text-sm fw-semibold">
                                                {product.currentPrice} <span className="text-gray-500 fw-normal text-xs">{product.quantityText}</span>
                                            </span>
                                            <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                                {product.originalPrice}
                                            </span>
                                        </div>

                                        <h6 className="title text-sm fw-semibold mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.4', height: '2.8em' }}>
                                            <Link to={`/product-details/${product.slug || product.id}`} className="link text-line-2">
                                                {product.name}
                                            </Link>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        );
                        })}
                        </Slider>
                    )}
                </div>
            </div>
        </section>
    )
}

export default NewArrivalOne
